import React, { memo } from 'react';
import type { FilterBooleanProps } from '../FilterPanel.types';

function FilterBooleanComponent({ config, value, onChange }: FilterBooleanProps): React.ReactElement {
  const handleToggle = () => {
    if (value === null || value === undefined) {
      onChange(true);
    } else if (value === true) {
      onChange(false);
    } else {
      onChange(null);
    }
  };

  return (
    <div>
      <label style={{
        display: 'block',
        fontSize: 'var(--text-xs)',
        fontWeight: 500,
        color: 'var(--color-text-secondary)',
        marginBottom: 'var(--space-1)'
      }}>
        {config.label}
      </label>
      <button
        onClick={handleToggle}
        role="switch"
        aria-checked={value === true}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--space-3)',
          padding: 'var(--space-2) var(--space-3)',
          width: '100%',
          fontSize: 'var(--text-sm)',
          fontFamily: 'var(--font-body)',
          textAlign: 'left',
          borderRadius: 'var(--radius-md)',
          border: '1px solid var(--color-border-default)',
          background: 'var(--color-bg-elevated)',
          color: 'var(--color-text-primary)',
          cursor: 'pointer',
          transition: 'all var(--transition-fast)'
        }}
      >
        {/* Toggle track */}
        <span style={{
          position: 'relative',
          width: '36px',
          height: '20px',
          borderRadius: 'var(--radius-full)',
          background: value === true
            ? 'var(--color-primary)'
            : value === false
              ? 'var(--color-negative-light)'
              : 'var(--color-neutral-300)',
          transition: 'background var(--transition-fast)',
          flexShrink: 0
        }}>
          {/* Toggle thumb */}
          <span style={{
            position: 'absolute',
            top: '2px',
            left: value === true ? '18px' : value === false ? '2px' : '10px',
            width: '16px',
            height: '16px',
            borderRadius: 'var(--radius-full)',
            background: 'white',
            boxShadow: 'var(--shadow-sm)',
            transition: 'left var(--transition-fast)'
          }} />
        </span>

        {/* Label */}
        <span style={{
          color: value === null ? 'var(--color-text-tertiary)' : 'var(--color-text-primary)'
        }}>
          {value === true
            ? 'Evet'
            : value === false
              ? 'Hayır'
              : 'Tümü'
          }
        </span>
      </button>
    </div>
  );
}

export const FilterBoolean = memo(FilterBooleanComponent);
